import { useState } from 'react';
import { useForm } from 'react-hook-form';

import Button from '../components/elements/Button';
import Label from '../components/elements/Forms/Label';
import TextInput from '../components/elements/Forms/TextInput';
import Heading2 from '../components/elements/Heading/Heading2';
import Link from '../components/elements/Link';
import Paragraph from '../components/elements/Paragraph';
import BasicCardLayout from '../components/modules/Layout/BasicLayout/BasicCardLayout';
import Seo from '../components/modules/Seo';
import SuccessAction from '../components/modules/SuccessAction';
import routes from '../config/routes';
import { remindPassword } from '../features/auth';

interface FormFields {
    email: string;
}

export default function RemindPassword(): JSX.Element {
    const [isError, setIsError] = useState<boolean>(false);
    const [isSuccess, setIsSuccess] = useState<boolean>(false);
    const { register, handleSubmit } = useForm<FormFields>();

    async function onSubmit(data: FormFields): Promise<void> {
        try {
            setIsError(false);
            if (data.email === '') {
                return;
            }
            await remindPassword(data.email);
            setIsSuccess(true);
        } catch (err) {
            setIsError(true);
            console.error('error', err);
        }
    }

    return (
        <BasicCardLayout>
            <Seo
                title="Réinitialiser mon mot de passe"
                description="Nous vous envoyons un e-mail avec un lien pour créer un nouveau mot de passe."
                url={routes.lostPassword.getUrl()}
                isCanonical
            />
            {!isSuccess ? (
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Heading2 className="!mt-0" level={1}>
                        Réinitialiser mon mot de passe
                    </Heading2>
                    <Paragraph className="mb-6">
                        Entrer votre adresse e-mail et nous vous enverrons un lien pour récupérer
                        votre compte.
                    </Paragraph>
                    <div className="mb-6">
                        <Label htmlFor="lostpassword-email">Adresse e-mail</Label>
                        <TextInput<FormFields>
                            id="lostpassword-email"
                            name="email"
                            type="email"
                            className="w-full"
                            register={register}
                        />
                    </div>
                    <Button className="!w-full mb-6" type="submit">
                        Envoyer un e-mail de réinitialisation
                    </Button>
                    {isError && (
                        <Paragraph variant="error" className="text-center mb-6">
                            Une erreur est survenue. Veuillez réessayer.
                        </Paragraph>
                    )}
                    <div className="text-center">
                        <Link href={routes.login.getUrl()}>Annuler</Link>
                    </div>
                </form>
            ) : (
                <SuccessAction
                    headerTitle="E-mail envoyé !"
                    text="L'e-mail de réinitialisation a été envoyé avec succès."
                />
            )}
        </BasicCardLayout>
    );
}
